module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": false
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('h2', {
    staticClass: "uppercase center",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.$t('skischool.explanation-title')))]), _vm._v(" "), _c('div', {
    staticClass: "items-list"
  }, _vm._l((_vm.infos), function(ref) {
    var title = ref.title;
    var description = ref.description;
    var color = ref.color;
    var text = ref.text;

    return _c('div', {
      staticClass: "item"
    }, [_c('div', {
      staticClass: "item-header"
    }, [_c('span', {
      staticClass: "circle",
      style: ({
        'background-color': color
      })
    }), _vm._v(" "), _c('span', {
      staticClass: "title",
      style: ({
        'color': color
      })
    }, [_vm._v(_vm._s(title))]), _c('span', {
      staticClass: "description"
    }, [_vm._v("— " + _vm._s(description))])]), _vm._v(" "), _c('div', {
      staticClass: "item-body"
    }, [_vm._v("\n        " + _vm._s(text) + "\n      ")])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d05b3e9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/SkiSchoolInfo.vue
// module id = 897
// module chunks = 0